import {
  AdminDatePickerInputModal,
  AdminDollarInput2,
  AdminRadioInput,
  AdminSwitch,
  Button,
  Div,
  ErrorToast,
  H5,
  Modal,
  P,
  PropsModal,
  Separator,
  dateTimeInitial,
  daysOfWeekFrom1,
  formatDateToTime24h,
} from '@vgrubs/components';
import { ScheduleEntity } from 'components/src/types/location.types';

import {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
} from 'react';

export const FundingTipAmountAndAddMultiple = ({
  modalIsOpen,
  closeModal,
  setFundedTipSchedule,
  fundingTipOrigin,
  setFundingTipOrigin,
  brandType,
}: PropsModal & {
  modalIsOpen: ScheduleEntity[] | null;
  setFundedTipSchedule: Dispatch<SetStateAction<ScheduleEntity[]>>;
  fundingTipOrigin?: boolean;
  brandType?: 'vGrubs' | 'vDrive';
  setFundingTipOrigin?: Dispatch<SetStateAction<boolean>>;
}) => {
  const [selectedDayOfWeek, setSelectedDayOfWeek] = useState([1]);
  const [timeFrom, setTimeFrom] = useState<Date[]>([dateTimeInitial]);
  const [timeTo, setTimeTo] = useState<Date[]>([dateTimeInitial]);
  const [fundedTip, setFundedTip] = useState(0);

  const [toggle, setToggle] = useState(false);

  const handleValueTipFunding = useCallback((val) => {
    setFundedTip(val);
  }, []);

  const fundedTipSchedule = modalIsOpen;
  const edit = fundedTipSchedule && fundedTipSchedule.length > 0;

  useEffect(() => {
    if (edit) {
      setFundedTip(fundedTipSchedule?.[0]?.amount || 0);
    }
    setToggle(fundingTipOrigin || false);
  }, [modalIsOpen]);

  const toggleDaySelection = (day) => {
    setSelectedDayOfWeek(
      (prevSelected) =>
        prevSelected.includes(day)
          ? prevSelected.filter((d) => d !== day) // Remove if already selected
          : [...prevSelected, day] // Add if not selected
    );
  };

  const handleFinishAction = () => {
    setSelectedDayOfWeek([]);
    setTimeFrom([dateTimeInitial]);
    setTimeTo([dateTimeInitial]);
    setFundedTip(0);
    closeModal?.();
  };

  const handleSubmit = () => {
    if (!edit) {
      if (selectedDayOfWeek.length === 0 || !timeFrom || !timeTo)
        return ErrorToast('Please fill in all information');
      if (timeFrom[0] >= timeTo[0])
        return ErrorToast('From time must be before to time');
    }

    if (edit) {
      setFundedTipSchedule((prev) => {
        if (!prev) return [];
        return prev.map((item) => ({
          ...item,
          amount: fundedTip,
        }));
      });
    } else {
      const multipleAdd = selectedDayOfWeek.map((day) => {
        return {
          amount: fundedTip,
          dayOfTheWeek: day,
          startTime: formatDateToTime24h(timeFrom[0]),
          endTime: formatDateToTime24h(timeTo[0]),
        };
      });
      setFundedTipSchedule(multipleAdd as ScheduleEntity[]);
    }
    if (brandType === 'vGrubs') {
      setFundingTipOrigin?.(toggle);
    }

    handleFinishAction();
  };

  return (
    <Modal
      isOpen={!!modalIsOpen}
      closeModal={closeModal}
      logo={false}
      header={`${edit ? 'Edit' : 'Add'} Tip Funding`}
      textAlign="left"
      width="500px"
    >
      <Div $mb={!edit ? '24' : undefined}>
        <AdminDollarInput2
          label="Tip Funding"
          onValueChange={handleValueTipFunding}
          value={fundedTip}
          $textCenter
        />
      </Div>

      {!edit && (
        <>
          <Separator />

          {daysOfWeekFrom1.map(({ name, value }) => (
            <div key={value}>
              <AdminRadioInput
                label={name}
                checked={selectedDayOfWeek.includes(value)}
                onClick={() => toggleDaySelection(value)}
              />
              <Separator />
            </div>
          ))}
          <H5 $mt="32" $mb="16" $center>
            Select Hours From - To
          </H5>
          <Div $flex $gap="24px">
            <AdminDatePickerInputModal
              format="hh:mm a"
              options={{
                enableTime: true,
                dateFormat: 'Y-m-d H:i',
                noCalendar: true,
              }}
              placeholder="From"
              $textCenter
              onChange={setTimeFrom}
              value={timeFrom}
            />
            <AdminDatePickerInputModal
              format="hh:mm a"
              options={{
                enableTime: true,
                dateFormat: 'Y-m-d H:i',
                noCalendar: true,
              }}
              placeholder="To"
              $textCenter
              onChange={setTimeTo}
              value={timeTo}
            />
          </Div>
        </>
      )}

      {brandType === 'vGrubs' && (
        <Div $flex $alignCenter $between $mt="32">
          <P $m="0">Apply Tip Funding Settings to All vGrubs Stores?</P>

          <AdminSwitch
            checked={toggle}
            onChange={() => setToggle((prev) => !prev)}
          />
        </Div>
      )}

      <Button $selected $w="100%" $mt="32" onClick={handleSubmit}>
        Confirm
      </Button>
      <Button $selected $gray $w="100%" $mt="16" onClick={handleFinishAction}>
        Cancel
      </Button>
    </Modal>
  );
};
